import type { AnalyticsPages } from '@/shared/types/analytics.types'
import { InboundFlowRoutes, OutboundFlowRoutes } from '@/shared/types/router.types'
import { TravelDirection } from '@/shared/types/common.types'

const INBOUND_ANALYTICS_PAGES: Partial<AnalyticsPages> = {
  [InboundFlowRoutes.RESIDENCE]: {
    page: 'select_country_of_residence',
    category: TravelDirection.INBOUND,
  },
  [InboundFlowRoutes.DATES]: {
    page: 'choose_travel_dates',
    category: TravelDirection.INBOUND,
  },
  [InboundFlowRoutes.TRAVELERS]: {
    page: 'number_of_travels',
    category: TravelDirection.INBOUND,
  },
  [InboundFlowRoutes.CONTACTS]: {
    page: 'enter_info',
    category: TravelDirection.INBOUND,
  },
  [InboundFlowRoutes.SELECT_PLANS]: {
    page: 'select_plan',
    category: TravelDirection.INBOUND,
  },
  [InboundFlowRoutes.PERSONAL_INFORMATION]: {
    page: 'holder_info',
    category: TravelDirection.INBOUND,
  },
  [InboundFlowRoutes.INSURED_TRAVELERS]: {
    page: 'insured_people',
    category: TravelDirection.INBOUND,
  },
  [InboundFlowRoutes.QUOTE]: {
    page: 'your_quote',
    category: TravelDirection.INBOUND,
  },
  [InboundFlowRoutes.INSURANCE_RESULT]: {
    page: 'download_policy',
    category: TravelDirection.INBOUND,
  },
}
const OUTBOUND_ANALYTICS_PAGES: Partial<AnalyticsPages> = {
  [OutboundFlowRoutes.DESTINATION]: {
    page: 'destination',
    category: TravelDirection.OUTBOUND,
  },
  [OutboundFlowRoutes.DATES]: {
    page: 'choose_travel_dates',
    category: TravelDirection.OUTBOUND,
  },
  [OutboundFlowRoutes.TRAVELERS]: {
    page: 'number_of_travels',
    category: TravelDirection.OUTBOUND,
  },
  [OutboundFlowRoutes.CONTACTS]: {
    page: 'enter_info',
    category: TravelDirection.OUTBOUND,
  },
  [OutboundFlowRoutes.SELECT_PLANS]: {
    page: 'select_plan',
    category: TravelDirection.OUTBOUND,
  },
  [OutboundFlowRoutes.PERSONAL_INFORMATION]: {
    page: 'holder_info',
    category: TravelDirection.OUTBOUND,
  },
  [OutboundFlowRoutes.INSURED_TRAVELERS]: {
    page: 'insured_people',
    category: TravelDirection.OUTBOUND,
  },
  [OutboundFlowRoutes.QUOTE]: {
    page: 'your_quote',
    category: TravelDirection.OUTBOUND,
  },
  [OutboundFlowRoutes.INSURANCE_RESULT]: {
    page: 'download_policy',
    category: TravelDirection.OUTBOUND,
  },
}

export const ANALITYCS_PAGES: Partial<AnalyticsPages> = {
  ...INBOUND_ANALYTICS_PAGES,
  ...OUTBOUND_ANALYTICS_PAGES,
}
